module.exports = __webpack_public_path__ + "static/media/62.9b0c2e7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/62.jpg
// module id = 1004
// module chunks = 0